module.exports = __webpack_public_path__ + "static/media/refresh.bbb46663.svg";